

































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import confirm from 'components/modals/Confirm'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import api from 'src/assets/api/gql'
import rest from 'src/assets/api/rest'
import AttendeeAttachmentUploadStart from 'src/graphql/attendee/AttendeeAttachmentUploadStart.gql'
import AttendeeAttachmentUploadComplete from 'src/graphql/attendee/AttendeeAttachmentUploadComplete.gql'
import AttendeeAttachmentDelete from 'src/graphql/attendee/AttendeeAttachmentDelete.gql'
import { QuizSlideResult, SlideParamsValuesSet } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    MarkdownViewerCrdt
  }
})
export default class ItemTopicViewerEssay extends Vue {
  response = ''
  attachments: string[] = []
  progress: number | null = null

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly seed!: string | undefined

  @Prop({ type: Object, default: () => { return {} } })
  readonly params!: SlideParamsValuesSet

  @Prop()
  readonly result!: QuizSlideResult | undefined

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: string[] | undefined

  get text () {
    return this.slide?.text?.getText()
  }

  get attachment () {
    if (this.attachments.length) {
      const attachment = this.attachments[ 0 ].split(/[?#,]/)
      return {
        id: attachment[ 1 ],
        src: attachment[ 0 ],
        name: attachment[ 3 ],
        type: attachment[ 2 ]
      }
    }
  }

  @Watch('value', { immediate: true })
  update (value: string[] | undefined) {
    const response: string[] = value ? [...value] : []
    this.response = response.shift() || ''
    this.attachments = response
  }

  async upload (file: File) {
    this.attachments = [`?#${file.type},${file.name}`]
    if (this.seed) {
      this.progress = 0
      let size = 0
      let type = null
      const form = new FormData()
      if (file.type.split('/').shift() === 'image') {
        const reduce = require('image-blob-reduce')()
        const blob = await reduce.toBlob(file, { max: 1920 })
        size = blob.size
        type = blob.type
        form.append('file', blob, file.name)
      } else {
        size = file.size
        type = file.type
        form.append('file', file)
      }

      const attendeeId = this.seed
      const name = file.name

      const { data: { attendeeAttachmentUploadStart: { jwtToken } } } = await api.query({
        query: AttendeeAttachmentUploadStart,
        variables: {
          input: { attendeeId, size, type, name }
        }
      })
      const response = await rest.upload('/api/file/upload', form, jwtToken, (event) => {
        this.progress = event.loaded / event.total
      })
      const { id, src } = JSON.parse((response.target as XMLHttpRequest)?.responseText)
      await api.mutate({
        query: AttendeeAttachmentUploadComplete,
        variables: {
          input: { attendeeId, src }
        }
      })

      this.progress = null

      this.attachments = [`${src}?${id}#${type},${name}`]
      this.$emit('input', [this.response || '', ...this.attachments])
    }
  }

  async uplaodClear () {
    if (this.attachment) {
      await confirm({
        title: this.$t('label.deleteConfirm').toString(),
        message: this.attachment.name
      })
      if (this.attachment.id) {
        const attendeeId = this.seed
        const id = +this.attachment.id
        await api.mutate({
          query: AttendeeAttachmentDelete,
          variables: {
            input: { attendeeId, id }
          }
        })
        this.attachments = []
        if (this.response) {
          this.$emit('input', [this.response])
        } else {
          this.$emit('input', undefined)
        }
      } else {
        this.attachments = []
      }
    }
  }

  respond (response: string) {
    this.response = response
    if (response || this.attachments.length) {
      this.$emit('input', [response || '', ...this.attachments])
    } else {
      this.$emit('input', undefined)
    }
  }
}
